import Api from '../api';
import { isEmpty as _isEmpty, omitBy as _omitBy } from 'lodash-es';
import QueryString from 'query-string';

export default class ChartApi extends Api {
  getChartData = async props => {
    const queryParams = { ...props };
    const queryObj = _omitBy(queryParams, _isEmpty);
    const queryString = QueryString.stringify(queryObj);

    try {
      const { data } = await this.get(`?${queryString}`);
      return data;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: 'Fail to get chart data.'
      };
    }
  };

  getKeyMetricsData = async props => {
    const queryParams = { ...props };
    const queryObj = _omitBy(queryParams, _isEmpty);
    const queryString = QueryString.stringify(queryObj);

    try {
      const { data } = await this.get(`keyinsights?${queryString}`);
      return data;
    } catch (error) {
      return {
        hasError: true,
        error: error.response,
        customMessage: 'Fail to get key insights.'
      };
    }
  };

getChannelList = async props => {
    const status = { ...props };
    const statusObj = _omitBy(status, _isEmpty);
    const statusString = !_isEmpty(statusObj) ? "?" + QueryString.stringify(statusObj) : "";
      try {
        const { data } = await this.get(`getNickName${statusString}`);
        return data;
      } catch (error) {
        return {
          hasError: true,
          error: error.response,
          customMessage: 'Fail to get channelList.'
        };
      }
    };
}